/**
 * 法人タイプ
 */
export const corporationTypeType = {
  // 診療所のみ開設している医療法人
  Type1: 'Type1',

  // 病院、老健または介護医療院のいずれか又は複数を開設している医療法人
  Type2: 'Type2',

  // 医療法第51条第２項に該当する（BS負債20億以上又はPL収益10億以上等）社会医療法人
  Type3: 'Type3',

  // 医療法第51条第２項に該当しない社会医療法人
  Type4: 'Type4',

  // 医療法第51条第２項に該当する（BS負債50億以上又はPL収益70億以上）医療法人
  Type5: 'Type5',

  // 地域医療連携推進法人
  Type6: 'Type6'
} as const
export type CorporationTypeType = typeof corporationTypeType[keyof typeof corporationTypeType];

/**
 * 消費税の経理方式
 */
export enum hospitalClinicKbnType {
    // 様式１（病院）
    Hospital = '01-01',
    // 様式２（診療所）
    Clinic = '02-01',
    // 様式３（報告対象外の医療法人）
    NonReportable = '03'
}

/**
 * 有無
 */
export enum HasCodeType {
  Yes = '１有',
  No = '２無'
}

/**
 * 消費税の経理方式
 */
export enum TaxAccountingMethodType {
  Excluded = '１税抜',
  Included = '２税込'
}

/**
 * 「病床機能報告」報告の有無
 */
export enum HasBedFunctionReportType {
  YesWithoutDispatch = '１有（派遣を含まない）',
  YesWithDispatch = '２有（派遣を含む）',
  No = '３無'
}

/**
 * 出力設定
 */
export enum OutputSettingType {
    All = 'All',
    BmnGroup = 'BmnGroup'
}
